
const m = window.require("embercom/config/environment");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
